import { toast } from 'sonner';
import { useAppStore } from '../store/appStore';
import { useAuthStore } from '../store/authStore';
import { useProductStore } from '../store/productStore';
import { useReceiptStore } from '../store/receiptStore';
import { submitDisposition } from '../services/api/deposit';
import { ScreenType, SubmitApiResult } from '../types';
import { SCREEN_TYPES } from 'utils/constants';
import { handleScanItemPageOpened } from '.';

export const handleProblemResolve = async (currentScreen: ScreenType): Promise<SubmitApiResult> => {
  const { user, stationId } = useAuthStore.getState();
  const { receiptData } = useReceiptStore.getState();
  const { currentProduct: productLine, setCurrentProduct } = useProductStore.getState();
  const { setCurrentScreen } = useAppStore.getState();

  try {
    let payload = {
      user_id: user.id,
      station_id: stationId,
      transaction_id: receiptData?.transaction_id || receiptData?.receipt?.transaction_id,
      problem_reason_msg: `Unexpected item scanned - Product: ${productLine?.product_id || 'Unknown'}`,
    };

    if (currentScreen === SCREEN_TYPES.SCAN_ITEM) {
      if (productLine) {
        // If an item is scanned, use item-specific reason
        if (productLine.exception_process === 'callback') {
          payload.problem_reason_msg = `Item requires callback - Grade: ${productLine.receipt_grade}`;
        } else if (productLine.exception_process === 'hold') {
          payload.problem_reason_msg = `Item on hold for review - Grade: ${productLine.receipt_grade}`;
        } else {
          payload.problem_reason_msg = `Item disposition: ${productLine.disposition_stage}`;
        }
      } else {
        // If no item scanned, mark receipt as having problem
        payload.problem_reason_msg = 'Receipt has problem - no specific item';
      }
    }

    if (currentScreen === SCREEN_TYPES.SCAN_ITEM || currentScreen === SCREEN_TYPES.CONFIRM_ITEM) {
      const result = await submitDisposition(payload);
      if (result?.responseState === 'confirmed') {
        toast.success('Problem reported successfully');
        if (currentScreen === SCREEN_TYPES.SCAN_ITEM) {
          setCurrentProduct(null);
          setCurrentScreen(SCREEN_TYPES.SCAN_BOX);
        } else if (currentScreen === SCREEN_TYPES.CONFIRM_ITEM) {
          handleScanItemPageOpened();
        }
        return { success: true };
      } else {
        toast.error(result?.responseMsg || 'Failed to report problem');
        return { success: false };
      }
    }
  } catch {
    toast.error('Network error. Please try again.');
    return { success: false };
  }
};
